import { createContext, useContext } from 'react';
import { DocumentModelMetadata } from 'types/dynamic-forms/DocumentModelMetadata';
import { DataSources } from 'types/dynamic-forms/DataSources';
import { DocumentProperty } from 'types/dynamic-forms/DocumentProperty';

export interface VersionLogContextValue {
  data: any;
  metadata: DocumentModelMetadata;
  dataSources: DataSources;
  properties: DocumentProperty[];
}

export const VersionLogContext = createContext<VersionLogContextValue | null>(null);

export function useVersionLogContext(): VersionLogContextValue {
  const context = useContext(VersionLogContext);
  if (!context) {
    throw new Error('useVersionLogContext must be used within a VersionLogContext.Provider');
  }
  return context;
}
